import { render, staticRenderFns } from "./TopPost.vue?vue&type=template&id=0f6806ee&scoped=true"
import script from "./TopPost.vue?vue&type=script&lang=js"
export * from "./TopPost.vue?vue&type=script&lang=js"
import style0 from "./TopPost.vue?vue&type=style&index=0&id=0f6806ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6806ee",
  null
  
)

export default component.exports